module.exports = __webpack_public_path__ + "img/5.9feb58a2.jpg";